export interface TableData {
  name: string;
  headers: string[];
  rows: { label: string; values: (string | number)[] }[];
  note?: string;
}

export interface SolutionProduct {
  id: string;
  num: string;
  title: string;
  description: string;
  tag: string;
  tagBg: string;
  image: string;
  tables: TableData[];
}


export const products: SolutionProduct[] = [
  {
    id: "esgoto",
    num: "01",
    title: "Tubo PVC Branco — Esgoto",
    description: "Tubos de PVC Rígidos utilizados em SISTEMAS PREDIAIS DE ESGOTO PRIMÁRIO E SECUNDÁRIO fabricados em barras de 3 m e 6 m, na cor \"Branca\", com ponta e bolsa.",
    tag: "Branco",
    tagBg: "bg-surface-dim text-neutral-deep ring-1 ring-surface-border",
    image: "/images/produtos/tubo-pvc-branco-esgoto.webp",
    tables: [{
      name: "PVC Branco – Esgoto",
      headers: ["Tubo", "Ø ENT (mm)", "Ø INT (mm)", "Parede (mm)"],
      rows: [
        { label: "40", values: [40.0, 37.8, 1.2] },
        { label: "50", values: [50.7, 47.5, 1.6] },
        { label: "75", values: [75.0, 72.1, 1.7] },
        { label: "100", values: [101.6, 98.4, 1.6] },
        { label: "100", values: [101.6, 97.8, 1.8] },
        { label: "150", values: [150.0, 145.0, 2.5] },
        { label: "200", values: [200.0, 193.0, 3.5] },
      ],
    }],
  },
  {
    id: "soldavel",
    num: "02",
    title: "Tubo PVC Marrom — Soldável",
    description: "Tubos de PVC Rígido utilizados em SISTEMAS PREDIAIS DE ÁGUA FRIA, fabricados em barras de 6 m, na cor \"Marrom\", com ponta e bolsa lisa. Indicado para pressão máxima de serviço (7,5 kgf/cm ou 75 mca), à temperatura de aproximadamente 20°C.",
    tag: "Marrom Soldável",
    tagBg: "bg-gold-dim text-gold-intense ring-1 ring-gold-border",
    image: "/images/produtos/tubo-pvc-marrom-soldavel.webp",
    tables: [{
      name: "PVC Marrom – Soldável",
      headers: ["Tubo", "Ø ENT (mm)", "Ø INT (mm)", "Parede (mm)"],
      rows: [
        { label: "20", values: [20.0, 17.0, 1.5] },
        { label: "25", values: [25.0, 21.6, 1.7] },
        { label: "32", values: [32.0, 27.8, 2.1] },
        { label: "40", values: [40.0, 35.2, 2.4] },
        { label: "50", values: [50.0, 44.0, 3.0] },
        { label: "60", values: [60.0, 53.4, 3.3] },
        { label: "85", values: [85.0, 75.6, 4.7] },
        { label: "110", values: [110, 97.8, 6.1] },
      ],
    }],
  },
  {
    id: "irrigacao",
    num: "03",
    title: "Tubo PVC Azul — Irrigação",
    description: "Tubos de PVC Rígido utilizado em SISTEMAS DE IRRIGAÇÃO, fabricados em barras de 6m, na cor \"Azul\" com ponta e bolsa lisa soldável indicado para pressão máxima de serviço (8,0 Kgf/cm ou 80 m.c.a.) à temperatura de aproximadamente 20ºC.",
    tag: "Azul",
    tagBg: "bg-accent-pale text-accent-deep ring-1 ring-surface-border",
    image: "/images/produtos/tubo-pvc-azul-irrigacao.webp",
    tables: [
      {
        name: "PN 80",
        headers: ["Tubo", "Ø ENT (mm)", "Ø INT (mm)", "Parede (mm)"],
        rows: [
          { label: "20", values: [20.0, 17.0, 1.5] },
          { label: "25", values: [25.0, 21.6, 1.7] },
          { label: "32", values: [32.0, 27.8, 2.1] },
          { label: "50", values: [50.5, 46.7, 1.9] },
          { label: "75", values: [75.5, 70.5, 2.5] },
          { label: "100", values: [101.6, 94.4, 3.6] },
          { label: "125", values: [125.0, 116.6, 4.2] },
        ],
      },
      {
        name: "PN 125",
        headers: ["Tubo", "Ø ENT (mm)", "Ø INT (mm)", "Parede (mm)"],
        rows: [
          { label: "100", values: [101.6, 92.40, 4.6] },
          { label: "125", values: [125.0, 113.80, 5.6] },
          { label: "150", values: [150.0, 137.80, 6.6] },
        ],
      },
    ],
  },
  {
    id: "irrigacao-defofo",
    num: "04",
    title: "Tubo Irrigação — JEI Defofo",
    description: "Utilizado em sistemas de irrigação para adução e distribuição de água à temperatura ambiente.",
    tag: "JEI Defofo",
    tagBg: "bg-accent-pale text-accent-deep ring-1 ring-surface-border",
    image: "/images/produtos/tubo-irrigacao-jei-defofo.webp",
    tables: [{
      name: "PN 125 JEI Defofo",
      headers: ["Tubo", "EXT", "INT", "L", "E"],
      rows: [
        { label: "100", values: [118, "108,4", 6000, 4.8] },
        { label: "150", values: [170, "156,4", 6000, 6.8] },
      ],
      note: "*As medidas de espessura e comprimento podem ser modificadas de acordo com a solicitação do cliente e a disponibilidade da empresa.",
    }],
  },
  {
    id: "coletor",
    num: "05",
    title: "Tubo PVC Ocre — Coletor Esgoto",
    description: "Tubos de PVC Rígido utilizados em SISTEMAS PREDIAIS, REDES COLETORAS PÚBLICAS E EFLUENTES INDUSTRIAIS, fabricados em barras de 6 m, na cor \"Ocre\", com bolsa JEI e ponta lisa, indicado para pressão máxima de serviço (2,5 kgf/cm ou 2500 Pa) à temperatura de aproximadamente 20 °C.",
    tag: "Ocre",
    tagBg: "bg-gold-dim text-gold-intense ring-1 ring-gold-border",
    image: "/images/produtos/tubo-pvc-ocre-coletor.webp",
    tables: [{
      name: "PVC Ocre – Coletor",
      headers: ["Tubo", "Ø ENT (mm)", "Ø INT (mm)", "Parede (mm)"],
      rows: [
        { label: "100", values: [110.0, 105.0, 2.5] },
        { label: "150", values: [160.0, 152.8, 3.6] },
        { label: "200", values: [200.0, 191.0, 4.5] },
      ],
    }],
  },
  {
    id: "pba-jei",
    num: "06",
    title: "Tubo PVC Marrom — PBA / JEI",
    description: "Tubos de PVC Rígido utilizados em ADUTORES E REDES DE ÁGUA, fabricados em barras de 6 m, na cor \"Marrom\", com bolsa JEI e ponta lisa indicado para pressão máxima de serviço. Classe 15 (7,5 kgf/cm ou 75 mca) Classe 12,5 (5,5 kgf/cm ou 55 mca) à temperatura de aproximadamente 20 °C.",
    tag: "PBA / JEI",
    tagBg: "bg-gold-dim text-gold-intense ring-1 ring-gold-border",
    image: "/images/produtos/tubo-pvc-marrom-pba-jei.webp",
    tables: [
      {
        name: "Classe 12",
        headers: ["Tubo", "Ø ENT (mm)", "Ø INT (mm)", "Parede (mm)"],
        rows: [
          { label: "60", values: [60.0, 54.6, 2.7] },
          { label: "75", values: [75.0, 68.2, 3.4] },
          { label: "85", values: [85.0, 77.2, 3.9] },
          { label: "110", values: [110.0, 100.0, 5.0] },
        ],
      },
      {
        name: "Classe 15",
        headers: ["Tubo", "Ø ENT (mm)", "Ø INT (mm)", "Parede (mm)"],
        rows: [
          { label: "60", values: [60.0, 53.4, 3.3] },
          { label: "75", values: [75.0, 66.6, 4.2] },
          { label: "85", values: [85.0, 75.6, 4.7] },
          { label: "110", values: [110.0, 97.8, 6.1] },
        ],
      },
    ],
  },
  {
    id: "eletroduto",
    num: "07",
    title: "Edutor ",
    description: "Tubo PVC Rígido Edutor utilizado na instalação de Bombas Submersas em poços artesianos, sendo fabricado em barra de 4 m.",
    tag: "Edutor ",
    tagBg: "bg-neutral-pale text-neutral-deep ring-1 ring-surface-border",
    image: "/images/produtos/eletroduto.webp",
    tables: [{
      name: "Edutor",
      headers: ["Ponta roscáveis (pol)", "Ø ENT (mm)", "Ø INT (mm)", "Parede (mm)"],
      rows: [
        { label: '1"', values: [33.7, 25.4, 4.15] },
        { label: '1 1/4"', values: [42.0, 32.0, 5.0] },
        { label: '1 1/2"', values: [48.0, 36.0, 6.0] },
        { label: '2"', values: [60.0, 48.0, 6.0] },
      ],
    }],
  },
  {
    id: "hidroponia",
    num: "08",
    title: "Tubos para Hidroponia",
    description: "Os tubos de PVC da Canaã são uma ótima opção para o sistema de hidroponia. São fabricados com matéria-prima reciclada e com ótimo custo-benefício.",
    tag: "Hidroponia",
    tagBg: "bg-success-pale text-success-deep ring-1 ring-surface-border",
    image: "/images/produtos/tubos-hidroponia.webp",
    tables: [{
      name: "Hidroponia",
      headers: ["Tubo", "Ø ENT (mm)", "Ø INT (mm)", "Parede (mm)"],
      rows: [
        { label: "40", values: [40.0, 37.6, 1.2] },
        { label: "50", values: [40.7, 47.5, 1.6] },
        { label: "75", values: [75.0, 71.6, 1.7] },
        { label: "100", values: [101.6, 98.0, 1.8] },
      ],
    }],
  },
  {
    id: "tubetes",
    num: "09",
    title: "Tubetes",
    description: "Reutilizáveis, resistentes à água e a substâncias tóxicas, recicláveis, ótimo custo-benefício. Fornecido em outras opções de cores, com opção de ranhuras internas e em tamanhos variados. <strong class=\"text-cinza-escuro font-bold\">Consultar quantidade por palete. Ideal para eixo de bobinas para indústria de embalagens flexíveis.</strong>",
    tag: "Tubetes",
    tagBg: "bg-gold-dim text-gold-intense ring-1 ring-gold-border",
    image: "/images/produtos/tubetes.webp",
    tables: [{
      name: "Tubetes",
      headers: ["Tubo", "Ø ENT (mm)", "Ø INT (mm)", "Peso Barra 6m (kg)"],
      rows: [
        { label: "84", values: [84.8, 3.3, 8.0] },
        { label: "85", values: [85.8, 4.6, 10.0] },
        { label: "87", values: [87.0, 4.7, 10.8] },
        { label: "88", values: [66.0, 4.8, 11.7] },
      ],
      note: "*As medidas de espessura e comprimento podem ser modificadas de acordo com a solicitação do cliente e a disponibilidade da empresa.",
    }],
  },
];
